import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database } from '@core';

import { FullLayout } from '../layout/layout';

export const getParametersByNames = async (
    supabase: SupabaseClient<Database>,
    swingUUID: string,
    parameterNames: string[],
) => {
    const { data, error } = await supabase
        .from('swings')
        .select(
            `
            id,
            analysis:swing_analyses!swing_analyses_swing_id_fkey(
                *,
                parameter_value:swing_measured_parameter_values!inner(
                    *,
                    parameter:swing_measured_parameters!inner(*)
                )
            )`,
        )
        .order('type_id', { referencedTable: 'analysis', ascending: false })
        .limit(1, { referencedTable: 'analysis' })
        .eq('uuid', swingUUID)
        .in('analysis.parameter_value.parameter.name', parameterNames)
        .single();

    if (error) {
        throw error;
    }
    const converted = camelcaseKeys(data, { deep: true });
    const analysis = converted.analysis.length ? converted.analysis[0] : null;
    if (!analysis) {
        throw new Error('no analysis found');
    }

    return analysis.parameterValue.map(({ value, parameter }) => ({
        ...parameter,
        value,
    }));
};

const ACTIVITY_NAVIGATION_NODE_ID = 'activity_navigation.default';

type KeyParameterUpdateArgs = { layoutId: number; keyParameterId: string };

export const keyParameterUpdate = async (
    supabase: SupabaseClient<Database>,
    { layoutId, keyParameterId }: KeyParameterUpdateArgs,
) => {
    const { data: response, error } = await supabase.functions.invoke<{ data: FullLayout }>('parameters-update', {
        body: {
            layoutId,
            moduleId: ACTIVITY_NAVIGATION_NODE_ID,
            showChildOn: null,
            parameterIds: [keyParameterId],
        },
    });
    if (error) {
        throw error;
    }

    return response?.data;
};
